// packages/ui/src/auth/AuthSplitLayout.tsx
import type { ReactNode } from 'react';

export interface AuthSplitLayoutProps {
  /** An AuthBrandPanel. */
  panel: ReactNode;
  /** An AuthMobileBar. */
  mobileBar: ReactNode;
  title: string;
  subtitle?: string;
  /** Extra classes for the h1, for an app that sets its heading font (font-display). */
  headingClassName?: string;
  children: ReactNode;
}

// Brand panel on the left from `lg`, the form column on the right. Below `lg` only the
// mobile bar and the form show.
export function AuthSplitLayout({ panel, mobileBar, title, subtitle, headingClassName, children }: AuthSplitLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {panel}
      <div className="flex-1 flex flex-col bg-white">
        {mobileBar}
        <main className="flex-1 flex items-center justify-center px-6 py-12">
          <div className="w-full max-w-sm">
            <div className="mb-8">
              <h1 className={`text-2xl font-bold text-slate-900 mb-2${headingClassName ? ` ${headingClassName}` : ''}`}>{title}</h1>
              {subtitle !== undefined && <p className="text-sm text-slate-500">{subtitle}</p>}
            </div>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
